<div class="notification">
  <div class="outline">
    <mat-icon>check</mat-icon>
  </div>
  <h2 mat-dialog-title class="notification__title">{{ data.title }}</h2>
  <div mat-dialog-content class="notification__body">
    <p class="notification__message">{{ data.message }}</p>
  </div>
  <div mat-dialog-actions class="notification__footer">
    <button
      type="button"
      color="primary"
      class="notification__button"
      mat-raised-button
      mat-dialog-close
    >
      Aceptar
    </button>
  </div>
</div>
